module.exports = __webpack_public_path__ + "img/Qi_Dai@2x.a9898ee4.png";